import { Component, Vue } from 'vue-property-decorator'

import CAAG1020ViewModel from './CAAG1020ViewModel'
import CAAG1020Service from './CAAG1020Service'
import CAAG1020ParamModel from './CAAG1020ParamModel'

import Header from '@/components/layout/header/HeaderNoRegister.vue'

import moment from 'moment'
import AirDatepicker from 'air-datepicker'

import SessionStorageService from '@/common/SessionStorageService'
import CommonConstants from '@/common/CommonConstants'
import OtherUrlConstants from '@/common/OtherUrlConstants'

import Store from '@/common/utils/Store'
import { fixedContentNoLogin } from '@/assets/js/main.js'

@Component({
  name: 'CAAG1020',
  components: { Header }
  })
export default class CAAG1020Controller extends Vue {
  private OtherUrlConstants = OtherUrlConstants

  /**
   * 業務日に応じたフォーマット
   * 業務日で選択できる月の最大値
   */
  private FORMAT_DATE = 'YYYY/MM/DD'
  private ADD_MONTH = 6
  private FORMAT_DATE_AIR_DATE_PICKER = 'yyyy/MM/dd'

  /**
   * 個人情報提供同意登録サービス
   */
  private caag1020Service = new CAAG1020Service()

  /**
   * 個人情報提供同意登録画面モデル
   */
  private caag1020ViewModel: CAAG1020ViewModel = {
    critDay: moment(new Date()).format(this.FORMAT_DATE),
    cntctNo: '',
    cmpnyNo: '',
    persnInfoAgrAvail: ''
  }

  private caag1020paramModel: CAAG1020ParamModel = this.$route
    .params as CAAG1020ParamModel

  /**
   * 画面要素描画後処理
   */
  mounted() {
    // 初期処理メソッドを呼出す
    this.init()
    fixedContentNoLogin()
  }

  /**
   * 初期処理
   */
  private init() {
    const configMinDate = moment().format(this.FORMAT_DATE)
    const configMaxDate = moment()
      .add(this.ADD_MONTH, 'month')
      .format(this.FORMAT_DATE)
    this.createDatepicker(
      configMinDate,
      configMaxDate,
      this.FORMAT_DATE_AIR_DATE_PICKER,
      '#critDay'
    )
  }

  /**
   * 基準日カレンダーアイコン押下
   * 基準日カレンダー確定ボタン押下
   * 基準日カレンダー「＜」「＞」ボタン押下
   * @param minDate
   * @param maxDate
   * @param dateFormat
   * @param divDatepicker
   */
  private createDatepicker(
    minDate: string,
    maxDate: string,
    dateFormat: string,
    divDatepicker: string
  ) {
    let val = null
    let isSelected = false
    const buttonOpen = document.querySelector('.form-date-picker__button-open')
    const button = {
      content: '確定',
      className: '',
      onClick: (datepicker) => {
        if (val || isSelected) {
          datepicker.$el.value = val
          this.caag1020ViewModel.critDay = val
        }
        datepicker.hide()
      }
    }
    const airDatepicker = new AirDatepicker(divDatepicker, {
      showOtherMonths: false,
      buttons: [button],
      nextHtml: `
    <svg  width="24" height="24" viewBox="0 0 24 24">
        <path d="M7.115 19.345C6.62623 19.8338 6.62623 20.6262 7.115 21.115C7.60377
         21.6038 8.39623 21.6038 8.885 21.115L17.2929 12.7071C17.6834 12.3166 17.6834
          11.6834 17.2929 11.2929L8.885 2.885C8.39623 2.39623 7.60377 2.39623 7.115 2.885C6.62623
           3.37377 6.62623 4.16623 7.115 4.655L14.46 12L7.115 19.345Z" fill="currentColor"></path>
    </svg>`,
      prevHtml: `
      <svg  width="24" height="24" viewBox="0 0 24 24">
        <path d="M16.885 4.655C17.3738 4.16623 17.3738 3.37377 16.885 2.885C16.3962 2.39623
         15.6038 2.39623 15.115 2.885L6.70711 11.2929C6.31658 11.6834 6.31658 12.3166 6.70711
          12.7071L15.115 21.115C15.6038 21.6038 16.3962 21.6038 16.885 21.115C17.3738 20.6262
          17.3738 19.8338 16.885 19.345L9.54 12L16.885 4.655Z" fill="currentColor"></path>
    </svg>`,
      minDate: minDate,
      maxDate: maxDate,
      locale: {
        days: [
          '日曜日',
          '月曜日',
          '火曜日',
          '水曜日',
          '木曜日',
          '金曜日',
          '土曜日'
        ],
        daysShort: ['日', '月', '火', '水', '木', '金', '土'],
        daysMin: ['日', '月', '火', '水', '木', '金', '土'],
        months: ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12'],
        monthsShort: [
          'Jan',
          'Feb',
          'Mar',
          'Apr',
          'May',
          'Jun',
          'Jul',
          'Aug',
          'Sep',
          'Oct',
          'Nov',
          'Dec'
        ],
        today: 'Today',
        clear: 'clear',
        dateFormat: dateFormat,
        firstDay: 0
      },
      navTitles: {
        days: '<span>yyyy</span>年<span>MM</span><span>月</span>'
      },
      onSelect: ({ formattedDate, datepicker }) => {
        isSelected = true
        datepicker.$el.value = this.caag1020ViewModel.critDay
        val = formattedDate || ''
      },
      isMobile: true,
      showEvent: '',
      selectedDates: [new Date(this.caag1020ViewModel.critDay)]
    })
    buttonOpen.addEventListener('click', function() {
      return airDatepicker.show()
    })
  }

  /**
   * 前に戻るボタン押下
   */
  private gotoCAAG1010() {
    this.$router.push({ name: 'caag1010' })
  }

  /**
   * 確定ボタン押下
   */
  private async gotoCAAG1060() {
    const isValid = this.caag1020Service.validationInput(
      this.caag1020ViewModel.cntctNo,
      this.caag1020ViewModel.cmpnyNo,
      this.caag1020ViewModel.persnInfoAgrAvail,
      this.caag1020ViewModel.critDay
    )
    if (!isValid) {
      const caaa1020ResponseModel = await this.caag1020Service.callAPICAAA1020(
        this.caag1020ViewModel.cntctNo,
        this.caag1020ViewModel.cmpnyNo,
        this.caag1020ViewModel.persnInfoAgrAvail,
        this.caag1020ViewModel.critDay?.replaceAll('/', '-')
      )

      if (caaa1020ResponseModel.rsltDiv === 1) {
        window.open('/dcweb/cust/CAAG1060', '_self')
      }
    }
  }
}
